<template>
  <div class="dynamic-array">
    <div
      v-if="isOnboardingRedesign"
      class="tw-mb-6"
    >
      <div class="tw-flex tw-gap-2 tw-items-center">
        <img
          :src="require('@/assets/images/onboarding/doctor-image.png')"
          alt=""
          class="tw-h-[70px] tw-mr-2"
        >
        <h2
          class="tw-mb-0 tw-flex-1"
          :class="['question-title tw-font-atten', body.header ? 'with-subtext' : '']"
        >
          {{ body.question }}
        </h2>
      </div>
    </div>
    <h2
      v-else
      class="question-title"
    >
      {{ body.question }}
    </h2>
    <!-- First allergy -->
    <p
      v-if="isOnboardingRedesign"
      class="tw-mb-2 tw-text-lg lg:tw-text-2xl"
    >
      Input your allergy here.
    </p>
    <div class="tw-relative">
      <b-form-input
        v-model="answers[0].allergy"
        type="text"
        :placeholder="isOnboardingRedesign ? 'Type here...' : 'Input your allergy here'"
        class="onboarding-input-lg"
        :class="{'tw-border-[#1a6a72]': isOnboardingRedesign && answers[0].allergy !== ''}"
      />
      <template v-if="isOnboardingRedesign && answers[0].allergy !== ''">
        <b-icon
          style="float: right; cursor: pointer"
          :class="{'text-primary': isOnboardingRedesign}"
          class="mb-3 tw-absolute tw-right-[1rem] tw-top-[50%] -tw-translate-y-1/2"
          icon="x-circle-fill"
          @click="()=>{
            answers[0].allergy = ''
            answers[0].effect = ''
          }"
        />
      </template>
    </div>
    
    <p
      v-if="isOnboardingRedesign && answers[0].allergy !== ''"
      class="tw-mb-2 tw-mt-8 tw-text-lg lg:tw-text-2xl"
    >
      Please explain your allergic reaction...
    </p>
    <b-form-textarea
      v-if="answers[0].allergy !== ''"
      v-model="answers[0].effect"
      class="mt-3 onboarding-textarea"
      style="border-radius: 0.5rem !important"
      rows="4"
      :placeholder="isOnboardingRedesign ? 'Type here...' : 'What happens when you take the drug above?'"
    />
    <!-- Subsequent allergies -->
    <div
      v-for="(answer, index) in answers"
      :key="index"
      class="tw-py-4"
    >
      <p
        v-if="isOnboardingRedesign && index > 0"
        class="tw-mb-2 tw-text-lg lg:tw-text-2xl"
      >
        Input your allergy here.
      </p>
      <div class="tw-relative">
        <b-icon
          v-if="index && answers[index].allergy !== ''"
          style="float: right; cursor: pointer"
          :class="{'text-primary tw-absolute tw-right-[1rem] tw-top-[50%] -tw-translate-y-1/2 tw-mb-0': isOnboardingRedesign, 'mb-3': !isOnboardingRedesign}"
          icon="x-circle-fill"
          @click="$delete(answers, index)"
        />
        
        <b-form-input
          v-if="index > 0"
          v-model="answers[index].allergy"
          type="text"
          :placeholder="isOnboardingRedesign ? 'Type here...' : 'Input your allergy here'"
          class="onboarding-input-lg"
          :class="{'tw-border-[#1a6a72]': isOnboardingRedesign && answers[index].allergy !== ''}"
        />
      </div>
      <p
        v-if="isOnboardingRedesign && index > 0 && answers[index].allergy !== ''"
        class="tw-mb-2 tw-mt-8 tw-text-lg lg:tw-text-2xl"
      >
        Please explain your allergic reaction...
      </p>
      <b-form-textarea
        v-if="index > 0 && answers[index].allergy !== ''"
        v-model="answers[index].effect"
        class="mt-3 onboarding-textarea"
        style="border-radius: 0.5rem !important"
        rows="4"
        :placeholder="isOnboardingRedesign ? 'Type here...' : 'What happens when you take the drug above?'"
      />
    </div>
    <u>
      <a
        v-if="activateControls"
        :class="isOnboardingRedesign ? `text-primary` : `text-info`"
        href="javascript:void(0)"
        @click="addAnswer"
      >+ Add another allergy
      </a>
    </u>
    <OnboardingCTAContainer>
      <b-button
        v-if="activateControls"
        pill
        block
        class="slight-rounded"
        :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
        variant="info"
        :disabled="isOnboardingRedesign ? (disabled || hasEmptyAnswer) : disabled"
        @click="checkAnswer"
      >
        Continue
      </b-button>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer.vue';

export default {
  components: {
    OnboardingCTAContainer,
  },
  props: {
    body: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answers: [{ allergy: '', effect: '' }],
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    activateControls() {
      return this.answers.length > 0 && this.answers[0].allergy !== '';
    },
    hasEmptyAnswer() {
      return this.answers.some(answer => answer.allergy === '' || answer.effect === '');
    },
  },
  mounted() {
    if (this.body.hasOwnProperty('answer')) {
      this.answers = this.body.answer;
    }
  },
  methods: {
    addAnswer() {
      this.answers.push({ allergy: '', effect: '' });
    },
    checkAnswer() {
      this.$emit('submitAnswer', this.body.id, this.answers, this.body);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control[type="text"] {
  border: 1px solid #C7C7C7;
  border-radius: 0.5rem;

  &:focus {
    border-color: $primary;
  }
}

textarea.form-control {
  background-color: #fafafa;
  border: 0;

  &:focus {
    background-color: #fafafa;
  }
}
</style>
